import { glass, theme } from "../../utils/theme";

export const styles = {
  bodyText: {
    color: theme.palette.grays[800],
    fontSize: {
      xs: theme.typography.body,
      md: theme.typography.body,
    },
    fontWeight: 300,
    mb: { xs: 4, md: 0 },
    mt: { xs: 6, md: 6 },
    textAlign: { xs: "start", md: "start" },
    textTransform: "none",
  },
  button: {
    // color: theme.palette.grays.white,
    mt: 5,
    minWidth: 200,
  },
  contactBackground: {
    height: "50%",
    right: { xs: "-90%", md: "-100%" },
    position: "absolute",
    top: { xs: "20%", md: "-60%" },
    zIndex: -1,
  },
  contactRoot: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    minHeight: "100vh",
    position: "relative",
    width: "100%",
  },
  error: {
    color: theme.palette.danger.main,
    fontSize: theme.typography.fontSize * 0.88,
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(7),
    marginTop: theme.spacing(7),
    width: "100%",
  },
  formRow: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    width: "100%",
    [theme.breakpoints.only("xs")]: {
      minWidth: "80%",
      marginBottom: theme.spacing(0),
      marginTop: theme.spacing(0),
    },
  },
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  input: {
    background: glass.background,
    backdropFilter: glass.backdropFilter,
    borderColor: theme.palette.grays[300],
    borderRadius: 2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: "none",
    flex: 1,
    marginRight: theme.spacing(2),
    [theme.breakpoints.only("xs")]: {
      marginBottom: theme.spacing(2),
      width: "100%",
    },
  },
  inputBase: {
    color: theme.palette.secondary.main,
    fontSize: theme.typography.body,
    padding: 2,
    width: "100%",
  },
  margin: {
    display: "flex",
    margin: 1,
  },
  selectButton: {
    alignItems: "center",
    background: glass.background,
    backdropFilter: glass.backdropFilter,
    borderColor: theme.palette.grays[300],
    borderRadius: 2,
    borderStyle: "solid",
    borderWidth: 1,
    color: theme.palette.grays[500],
    cursor: "pointer",
    display: "flex",
    mb: 0.5,
    padding: 2,
  },
  selectFormContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    mr: 2,
    position: "relative",
    [theme.breakpoints.only("xs")]: {
      marginBottom: theme.spacing(2),
      width: "100%",
    },
  },
  selectFormLabel: {
    color: theme.palette.secondary.main,
    fontSize: theme.typography.body,
  },
  selectFormValue: {
    color: theme.palette.secondary.main,
    fontSize: theme.typography.body,
  },
  selectMenu: {
    alignItems: "flex-start",
    background: glass.background,
    backdropFilter: glass.backdropFilter,
    borderColor: theme.palette.grays[300],
    borderRadius: 2,
    borderStyle: "solid",
    borderWidth: 1,
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    padding: `${theme.spacing(3)} 0`,
    zIndex: 1,
  },
  selectMenuLabel: {
    color: theme.palette.accent.main,
    fontSize: theme.typography.fontSize * 0.88,
    mb: 1.2,
    padding: `0 ${theme.spacing(5)}`,
  },
  selectOption: {
    padding: `${theme.spacing(2)} ${theme.spacing(5)}`,
    width: "100%",
    "&:hover": {
      background: "rgba(210, 210, 210, 0.2)",
    },
  },
  selectOptionLabel: {
    fontSize: theme.typography.fontSize * 1,
    color: theme.palette.secondary.main,
  },
  selectOptionLabelActive: {
    fontSize: theme.typography.fontSize * 1,
    color: theme.palette.primary.main,
  },
};
